import { Filter, X } from "lucide-react";
import { useState } from "react";
import DateRangePicker from "../../../../components/ui/DateRangePicker";
import { Modal } from "../../../../components/ui/Modal";
import { MySelect } from "../../../../components/ui/Select";
import { cn } from "../../../../lib/utils";

interface FinanceFilterComponentProps {
  onApplyFilters: (filters: {
    startDate: string;
    endDate: string;
    category: string;
  }) => void;
}

const DispatchFilterComponent: React.FC<FinanceFilterComponentProps> = ({
  onApplyFilters,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [dates, setDates] = useState({
    startDate: "",
    endDate: "",
  });
  const [category, setCategory] = useState("");
  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    category: "",
  });

  return (
    <div>
      <button
        onClick={() => setOpenModal(true)}
        className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-100 transition"
      >
        <Filter className="h-4 w-4 text-gray-600" />
        <span className="text-sm text-gray-700 font-medium">Filter</span>
      </button>

      <Modal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        className="p-6 max-w-lg mx-auto"
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-200 pb-3 mb-6">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Advanced Filters
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Refine your search to find exactly what you’re looking for.
            </p>
          </div>
          <button
            onClick={() => setOpenModal(false)}
            className="p-2 hover:bg-gray-100 rounded-lg transition"
            aria-label="Close filter modal"
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>

        {/* Filters */}
        <div className="space-y-6">
          {/* Date Range */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date Range
            </label>
            <p className="text-xs text-gray-500 mb-2">
              Choose the time period for your data.
            </p>
            <DateRangePicker value={dates} onChange={setDates} />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Category
            </label>
            <p className="text-xs text-gray-500 mb-2">Filter by category.</p>
            <MySelect<string>
              name={"name"}
              id={"id"}
              label={""}
              options={["All", "Active", "Inactive", "UnderRepair"]}
              getValue={(option: string) => option}
              getName={(option: string) => option}
              value={category}
              onChange={(e) => setCategory(e)}
              onValChange={(e) => setCategory(e)}
              placeholder={"Category"}
              className={cn(
                "focus:ring-primary focus:border-primary",

                "h-[42px] text-[16px] px-2 text-[#535353] appearance-none bg-white border border-[#CECECE] rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
              )}
            />
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200 mt-6">
          <button
            onClick={() => {
              setDates({
                startDate: "",
                endDate: "",
              });
              setCategory("");

              setFilterData({
                startDate: "",
                endDate: "",
                category: "",
              });
              onApplyFilters({
                startDate: "",
                endDate: "",
                category: "",
              });
            }}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition"
          >
            Reset
          </button>
          <button
            onClick={() => {
              const filters = {
                ...dates,
                category,
              };
              setFilterData(filters);
              onApplyFilters(filters);
              setOpenModal(false);
            }}
            className="px-5 py-2 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary/90 transition"
          >
            Apply Filters
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default DispatchFilterComponent;
